import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
import { SnackbarProvider, withSnackbar } from 'notistack';
import { withRouter } from 'react-router';
import Styles from '../GeneralUI/Styles';
import { errorSetter } from '../../Libs';
import _ from 'lodash';
import Utils from '../../Libs/utils';
import { saveCustom, getDocument, handlerPselect } from '../../Actions/General'
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import Visibility from '@material-ui/icons/Visibility';

class EncuestaTransporte extends Component {
  constructor(props) {
    super(props);

    this.setErrors = errorSetter.setErrors.bind(this);
  }

  state = {
    fields: {
      enctraCodigo:null,
      enctraNombre:'ENCUESTA TRANSPORTE',
      clienteNombreCompleto:'',
      pedidoCodigo:null,

      enctraDeclaraValorBienes:'NO',
      enctraAceptaSeguroTransporte:'NO',
      enctraRevisaronPantallas:'NO',
      enctraSolicitaTrasladoSinEmpaque:'NO',
      enctraSolicitaTrasladoNoEmpaqueBodehogar:'NO',
      enctraAceptaContrato:'NO',
      enctraObservacion:null,
      enctraEstado:'PENDIENTE',

      createdAt: Utils.fullDateTime(),
      updatedAt: Utils.fullDateTime()
    },
    responseForm: { Message: '', typeMessage: '' },
    urlSave:'/processes/save_encuesta_transporte',
    urlGet:'/processes/get_encuesta_transporte',
    formErrors: {
      enctraDeclaraValorBienes: {},
      enctraAceptaSeguroTransporte: {},
      enctraRevisaronPantallas: {},
      enctraSolicitaTrasladoSinEmpaque: {},
      enctraSolicitaTrasladoNoEmpaqueBodehogar: {},
      enctraAceptaContrato: {},
    },

    responseForm: { Message: '', typeMessage: '' },

    formValidations: {
      view: ['enctraDeclaraValorBienes', 'enctraAceptaSeguroTransporte', 'enctraRevisaronPantallas', 'enctraSolicitaTrasladoSinEmpaque', 'enctraSolicitaTrasladoNoEmpaqueBodehogar', 'enctraAceptaContrato']
    }

  };

  componentDidMount() {

    // recuperamos el querystring
    const querystring = window.location.search
    const params = new URLSearchParams(querystring)
   
    if (!params.has("Codigo")) {
      return;
    }
  
    this.fillFormData(params.get('Codigo'));   
    this.props.toggleFavorites();
  }


  fillFormData  (id) {

      let document, data; 

      if (!id) {
        return;
      }

      document=saveCustom({codigo:id}, this.state.urlGet);

      document.then(data => {

          this.setState({ fields: data });
      }).catch(error => {
          this.message("error","El Registro NO ha sido Guardado." + error.errorMessage);
      });        
  }

  componentWillUnmount() {
    this.props.toogleFavoritesShow();
  }
 
  handleChange = (event) => {
    let { fields } = this.state;
    const caret = event.target.selectionStart;
    const element = event.target;
    if (element.hasOwnProperty('setSelectionRange')) {
      window.requestAnimationFrame(() => {
        element.setSelectionRange(caret, caret);
      });
    }

    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'radio') {
      fields[event.target.name] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }

    if (fields[event.target.id] === '') {
      fields[event.target.id] = null;
    }
    this.setState({ fields });
  }

  getSaveFunction() {
      return saveCustom(this.state, this.state.urlSave);
  }

  save = () => {
    if(this.validaData()){
      this.getSaveFunction().then(data => {
        this.message("success","El Registro ha sido Guardado.");
      }).catch(error => {
        this.message("error","El Registro NO ha sido Guardado." + error.errorMessage);
      });        
    }
    
  }

  message = (type, message) => {
    this.props.enqueueSnackbar(message, { variant: type });
  }

  validaData = () => {
    let isvalid = true, message = '', type = "";

    if ((this.state.fields.enctraDeclaraValorBienes == null || !String(this.state.fields.enctraDeclaraValorBienes).trim())) {
      message = "1. ¿Declara valor de bienes superior a 100 millones?";
      type = "error";
      isvalid = false;
    }

    if ((this.state.fields.enctraAceptaSeguroTransporte == null || !String(this.state.fields.enctraAceptaSeguroTransporte).trim())) {
      message = "2. ¿Acepta tomar seguro de transporte?";
      type = "error";
      isvalid = false;
    }

    if ((this.state.fields.enctraRevisaronPantallas == null || !String(this.state.fields.enctraRevisaronPantallas).trim())) {
      message = "3. ¿Se revisaron pantallas?";
      type = "error";
      isvalid = false;
    }

    if ((this.state.fields.enctraSolicitaTrasladoSinEmpaque == null || !String(this.state.fields.enctraSolicitaTrasladoSinEmpaque).trim())) {
      message = "4. ¿Solicito traslado de sus bienes sin empaque?";
      type = "error";
      isvalid = false;
    }

    if ((this.state.fields.enctraSolicitaTrasladoNoEmpaqueBodehogar == null || !String(this.state.fields.enctraSolicitaTrasladoNoEmpaqueBodehogar).trim())) {
      message = "5. ¿Solicitó traslado de bienes no empacados por Bodehogar?";
      type = "error";
      isvalid = false;
    }

    if ((this.state.fields.enctraAceptaContrato == null || !String(this.state.fields.enctraAceptaContrato).trim())) {
      message = "¿Acepta los terminos y condiciones?";
      type = "error";
      isvalid = false;
    }

    this.message(type,message);
    return isvalid;
  }

  render() {
    const { classes } = this.props; 

    return (
      <Paper elevation={5} className={`${classes.mainPaper} ${classes.fullWidthPaper}`}>
        <Grid container spacing={4}>
          <Grid item xs={3} className={classes.gridForm}>
            <img alt='background' src="/bodehogar2.png" width="40%" height="70%" />
          </Grid>
          <Grid item xs className={classes.gridForm}>
            <InputLabel className={classes.tittleLabelForm}>
              ENCUESTA TRANSPORTE.
            </InputLabel>

              <Grid item xs={3} className={this.props.classes.chipTitle}>
              {(this.state.fields.enctraCodigo !== null) ?
                (<Chip
                  label={this.state.fields["enctraCodigo"]}
                  clickable
                  color="primary"
                  onDelete={this.handleSeguir}
                  deleteIcon={<Tooltip title="Seguir" placement="right-start"><Visibility /></Tooltip>}
                />) : ''
              }
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid item xs className={this.props.classes.gridForm}>
                {((Utils.getFromLocalStorage('userInfo')?.usuarioNombreCompleto || '') == 'JENNY PAOLA ROCHA' ||
                  (Utils.getFromLocalStorage('userInfo')?.usuarioNombreCompleto || '') == 'LUIS NABOR MARINEZ ANGULO' ||
                  (Utils.getFromLocalStorage('userInfo')?.usuarioNombreCompleto || '') == 'MARIVEL CECILIA MANJARRES BOTTO'
                  ) ? 
                    (
                    <InputLabel className={classes.tittleLabelEncuesta}>                      
                      {this.state.fields["enctraInformacionUsuario"] || undefined}
                    </InputLabel>
                    ) : ''
                  } 
            </Grid>
        </Grid> 

        <Grid container spacing={2}>
            <Grid item xs className={this.props.classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                {this.state.fields["clienteNombreCompleto"] || undefined}
                </InputLabel>
            </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                    1. ¿Declara valor de bienes superior a 100 millones?
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="enctraDeclaraValorBienes"
                    value={this.state.fields["enctraDeclaraValorBienes"] || undefined}
                    formErrors={this.state.formErrors['enctraDeclaraValorBienes']}
                    disabled
                  >
                    <FormControlLabel value="SI" control={<Radio />} label="SI" />
                    <FormControlLabel value="NO" control={<Radio />} label="NO" />
                  </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                    2. ¿Acepta tomar seguro de transporte?
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="enctraAceptaSeguroTransporte"
                    value={this.state.fields["enctraAceptaSeguroTransporte"] || undefined}
                    formErrors={this.state.formErrors['enctraAceptaSeguroTransporte']}
                    disabled
                  >
                    <FormControlLabel value="SI" control={<Radio />} label="SI" />
                    <FormControlLabel value="NO" control={<Radio />} label="NO" />
                  </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                    3. ¿Se revisaron pantallas?
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="enctraRevisaronPantallas"
                    value={this.state.fields["enctraRevisaronPantallas"] || undefined}
                    formErrors={this.state.formErrors['enctraRevisaronPantallas']}    
                    disabled                
                  >
                    <FormControlLabel value="SI" control={<Radio />} label="SI" />
                    <FormControlLabel value="NO" control={<Radio />} label="NO" />
                  </RadioGroup>
                </FormControl>
            </Grid>
          </Grid> 
      
          <Grid container spacing={2}>
            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                    4. ¿Solicito traslado de sus bienes sin empaque?
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="enctraSolicitaTrasladoSinEmpaque"
                    value={this.state.fields["enctraSolicitaTrasladoSinEmpaque"] || undefined}
                    formErrors={this.state.formErrors['enctraSolicitaTrasladoSinEmpaque']}  
                    disabled                  
                  >
                    <FormControlLabel value="SI" control={<Radio />} label="SI" />
                    <FormControlLabel value="NO" control={<Radio />} label="NO" />
                  </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                    5. ¿Solicitó traslado de bienes no empacados por Bodehogar?
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="enctraSolicitaTrasladoNoEmpaqueBodehogar"
                    value={this.state.fields["enctraSolicitaTrasladoNoEmpaqueBodehogar"] || undefined}
                    formErrors={this.state.formErrors['enctraSolicitaTrasladoNoEmpaqueBodehogar']}  
                    disabled                  
                  >
                    <FormControlLabel value="SI" control={<Radio />} label="SI" />
                    <FormControlLabel value="NO" control={<Radio />} label="NO" />
                  </RadioGroup>
                </FormControl>
            </Grid> 
            <Grid item xs className={classes.gridForm}>
              <TextField id="enctraObservacion" label="Observacion" type="text"
                placeholder="Observacion" multiline
                rows={5}
                variant="outlined"
                fullWidth margin="normal" 
                InputLabelProps={{ shrink: true }} 
                value={this.state.fields["enctraObservacion"] || undefined}
                disabled
              />
            </Grid>           
          </Grid> 

          <Grid container spacing={2}>
            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                   ¿Acepta los terminos y condiciones?
                </InputLabel>
                {((Utils.getFromLocalStorage('userInfo')===null) && this.state.fields["enctraEstado"]=='PENDIENTE') || true ?
                 ( <Link to={`/imprimir?file=impresion_pedido_contrato_transporte_bodehogar.json&ID=${this.state.fields["pedidoCodigo"]}`} target="_blank"><Chip
                    label="VER CONTRATO."
                    clickable
                    className={this.props.classes.chip}
                    color="primary"
                  /></Link> 
                  ) : ''}

                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="enctraAceptaContrato"
                    onChange={this.handleChange}
                    value={this.state.fields["enctraAceptaContrato"] || undefined}
                    formErrors={this.state.formErrors['enctraAceptaContrato']}                    
                  >
                    <FormControlLabel value="SI" control={<Radio />} label="SI" />
                    <FormControlLabel value="NO" control={<Radio />} label="NO" />
                  </RadioGroup>
                </FormControl>
            </Grid>            
          </Grid> 
          
        <Grid container spacing={10} >
          <Grid item xs={3} className={this.props.classes.gridForm}>              
              {((Utils.getFromLocalStorage('userInfo')===null) && this.state.fields["enctraEstado"]=='PENDIENTE') || true ?
                (<Button
                  color='primary'
                  variant='contained'
                  onClick={(event) => this.save()}
                >
                Enviar
              </Button>
                ) : ''
              }
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

EncuestaTransporte.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  toggleFavorites: PropTypes.func.isRequired,
  toogleFavoritesShow: PropTypes.func.isRequired
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(EncuestaTransporte)));

function IntegrationNotistack(props) {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp {...props} />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;